import {
    initCarouselForLargeShopPromosLegacy,
    initCinemasForSmallShopPromosLegacy,
} from './init';
import { Logger } from "./logger";
import ShopPromoLargeCard from "./large/shoppromo_large_card";
import ShopPromoSmallCard from "./small/shoppromo_small_card";
import PromoBrandShopPromo from "./brand/promo_brandshoppromo";

window.o_promo_shoppromo = {
    ShopPromoLargeCard,
    ShopPromoSmallCard,
    PromoBrandShopPromo,
    initCinemasForSmallShopPromosLegacy,
    initCarouselForLargeShopPromosLegacy,
}

Logger.log("Module ft3.promo.shoppromo module is loaded and the global o_promo_shoppromo object is initialized. The initialization is triggered directly in the template!");